<template>
  <div
    v-if="Object.keys(data).length"
    class="gc"
    :class="{
      'active': isFavorites,
      'is-large': isLarge,
      'is-hover': isMouseOver,
    }"
    @mouseleave="isMouseOver = false"
    @mouseover="isMouseOver = true"
  >
    <div class="gc__wrap">
      <div class="gc__wrap-img">
        <img
          v-lazy="`${$config.cloudUrl}${data.iconUrlVertical}`"
          :src="$pixel"
          :alt="data.name"
          class="gc__img"
          width="100"
          height="100"
        />
      </div>

      <div
        v-if="isShowFooter"
        class="gc__footer"
        :data-name="data.provider.name"
        :style="{
          '--provider-icon': `url(${$config.cloudUrl}${data.provider.iconUrl})`,
        }"
      />

      <ClientOnly>
        <FavoriteBtn
          :is-show="isShowFavoritesBtn"
          :is-favorites="isFavorites"
          :is-inverse="isMouseOver"
          class="gc__fav-btn"
          @click="favToggle"
        />
      </ClientOnly>

      <NuxtLink
        :to="`${$paths.gamePath}/${playLink}`"
        :data-id="`game-click-${playLink}`"
        prefetch
        class="gc__link"
        :class="{ 'clicked' : !isPreventLink }"
      >
        <div
          v-if="data.labels && data.labels.length"
          class="gc__stickers"
        >
          <UiBadge
            v-for="label in data.labels"
            :key="label.id"
            size="small"
            :icon-url="`${$config.cloudUrl}${label.iconUrl}`"
            :text="label.nameUa"
            :style="{
              color: label.textColor,
              backgroundColor: label.backgroundColor,
            }"
          />
        </div>

        <Transition name="fade" mode="out-in">
          <div
            v-if="isMouseOver"
            class="gc__desc"
            @click="switchMouseOverMobile($event)"
          >
            <UiBtn
              v-if="isHideDemoBtn"
              :text="$t('cards.demo')"
              tag="div"
              :size="{ default: 'xs', 'tablet-album': 's' }"
              color="gray"
              class="gc__demo"
            />
            <UiBtn
              v-if="isHideDemoBtn"
              tag="div"
              size="xs"
              icon="lobby/play"
              class="gc__demo-mob"
            />
            <UiText
              class="gc__game-title-hover"
              font="promo-heading-4"
              align-center
              color="neutral-b10"
              :text="data.name"
            />

            <UiBtn
              class="gc__btn"
              color="primary"
              :size="{ default: isLarge ? 's' : 'xs', 'mobile-last': 's', 'tablet-album': 'm' }"
              tag="div"
              full-width
              :data-id="`gc-btn-play-mobile-${playLink}`"
              :text="$tc('popup.btnPlay')"
              @click="$router.push(`${$paths.gamePath}/${playLink}`)"
            />
          </div>
        </Transition>
      </NuxtLink>
    </div>

    <LargeCardPanel
      v-if="isLarge"
      :live-table-data="liveTableData"
      :card-data="data"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FavoriteBtn from '@/components/shared/Cards/CardGame/FavoriteBtn'
import { PRAGMATIC_LIVE_TERM, GAME_TYPE } from '~/components/Lobby/enum'
import LargeCardPanel from '~/components/shared/Cards/CardGame/LargeCardPanel'

export default {
  name: 'CardGame',
  components: {
    LargeCardPanel,
    FavoriteBtn,
  },
  props: {
    data: { type: Object, default: () => ({}) },
    isLarge: { type: Boolean },
    isFooter: { type: Boolean, default: true },
  },
  data() {
    return {
      isMouseOver: false,
      isPreventLink: true,
      isFetching: false,
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('lobby', ['get_favoritesMetaList']),
    ...mapGetters('pragmaticLive', [
      'get_pragmaticLiveAvailableTableIdList',
      'get_liveTablesMessage',
    ]),
    playLink() {
      return this.data?.term
    },
    liveTableId() {
      return this.data?.code
    },
    isReceiveLiveUpdates() {
      return this.data?.provider?.term === PRAGMATIC_LIVE_TERM
        && this.isLarge
    },
    liveTableData() {
      return this.get_liveTablesMessage(this.liveTableId) || {}
    },
    isFavorites() {
      if (this.isLoggedIn && this.get_favoritesMetaList.data?.length) {
        return this.get_favoritesMetaList.data.some((term) => term === this.data?.term)
      }
      return false
    },
    isShowFavoritesBtn() {
      return this.isFavorites || this.isMouseOver
    },
    isShowFooter() {
      return this.isFooter && !this.isLarge && this.data?.provider && this.data?.provider?.name && this.data?.provider?.iconUrl
    },
    isLiveGame() {
      return this.data.type === GAME_TYPE.LIVE
    },
    isHideDemoBtn() {
      return !this.isLoggedIn && !this.isLarge && !this.isLiveGame
    },
  },
  watch: {
    isMouseOver() {
      setTimeout(() => {
        this.isPreventLink = !this.isMouseOver
      })
    },
  },
  created() {
    if (process.server) return
    if (this.isReceiveLiveUpdates) {
      this.$pragmaticLive.addToTableIdToList(this.liveTableId)
    }
  },
  methods: {
    ...mapActions('lobby', ['toggle_gameFavorites']),
    ...mapActions('globalModal', ['close_globalModal']),
    async favToggle() {
      if (this.isLoggedIn) {
        if (this.isFetching) return
        this.isFetching = true
        this.toggle_gameFavorites({
          game: this.data?.term,
          toggle: !this.isFavorites,
        })
        this.isFetching = false
      }
      else {
        this.close_globalModal()
        this.$newModal.openAuthOrRegister()
      }
    },
    switchMouseOverMobile(e) {
      if (this.$device.isMobile) {
        // e.preventDefault()
        this.isMouseOver = false
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
